<div class="upp-barcode-display">
    <ng-container *ngIf="!HasValue">
        <upp-form-warning *ngIf="mode === 'EDIT' && !disabled" uppDataid="barcode-assign"
            color="medium"
            icon="barcode-outline"
            [title]="tr('@place_barcode_assign')"
            [subtitle]="tr('@place_barcode_assign_message')"
            (click)="OnAssign()"
        ></upp-form-warning>
    </ng-container>

    <ng-container *ngIf="HasValue">
        <div class="upp-barcode-display-preview">
            <div class="upp-barcode-display-canvas">
                <svg #svg class="upp-barcode-display-image" [style.display]="ImageVisible ? 'block' : 'none'"></svg>
            </div>
            <div class="upp-barcode-display-text">{{ TextValue }}</div>
        </div>
        <div *ngIf="mode === 'EDIT' && !disabled" class="upp-barcode-display-actions">
            <ion-button uppDataid="barcode-remove-button"
                fill="clear"
                color="danger"
                (click)="OnRemove()"
            >
                {{tr('@place_barcode_remove')}}
            </ion-button>
            <ion-button uppDataid="barcode-update-button"
                fill="clear"
                color="primary"
                (click)="OnAssign()"
            >
                {{tr('@place_barcode_update')}}
            </ion-button>
        </div>
    </ng-container>
</div>

<upp-barcode-scanning
    [active]="Listening"
    (OnCode)="OnScanCode($event)"
    (OnCancel)="OnScanCancel()"
></upp-barcode-scanning>
